import { render, staticRenderFns } from "./case-notes-table.vue?vue&type=template&id=440dc65c"
import script from "./case-notes-table.vue?vue&type=script&lang=js"
export * from "./case-notes-table.vue?vue&type=script&lang=js"
import style0 from "./case-notes-table.vue?vue&type=style&index=0&id=440dc65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports